<template>
  <div class="case-carousel-section" v-if="caseList.length > 0">
    <div class="section-header">
      <h2 class="section-title">纹发效果</h2>
    </div>
    
    <div class="carousel-container">
      <div class="seamless-scroll-wrapper" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
        <div class="scroll-content" :style="scrollStyle">
          <!-- 原始列表 -->
          <div 
            v-for="item in displayList" 
            :key="'original-' + item.id"
            class="case-item" 
            @click="openCaseDetail(item.id)"
          >
            <div class="case-image-wrapper">
              <img :src="item.image" :alt="'案例 ' + item.id" class="case-image" />
              <div class="case-overlay">
                <div class="case-info">
                  <span class="view-detail">查看详情 →</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 克隆列表用于无缝滚动 -->
          <div 
            v-for="item in displayList" 
            :key="'clone-' + item.id"
            class="case-item" 
            @click="openCaseDetail(item.id)"
          >
            <div class="case-image-wrapper">
              <img :src="item.image" :alt="'案例 ' + item.id" class="case-image" />
              <div class="case-overlay">
                <div class="case-info">
                  <span class="view-detail">查看详情 →</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFeaturedCases } from '../../api/case'

export default {
  name: 'CaseCarousel',
  data() {
    return {
      caseList: [],
      scrollOffset: 0,
      animationId: null,
      isPaused: false,
      scrollSpeed: 1 // 滚动速度，可调整
    }
  },
  computed: {
    displayList() {
      return this.caseList
    },
    scrollStyle() {
      return {
        transform: `translateX(-${this.scrollOffset}px)`,
        transition: 'none'
      }
    }
  },
  methods: {
    async getCasesFunc() {
      try {
        const res = await getFeaturedCases(8)
        if (res.data && res.data.data) {
          this.caseList = res.data.data
          // 数据加载完成后开始滚动
          this.$nextTick(() => {
            this.startScroll()
          })
        }
      } catch (error) {
        console.error('加载客户案例失败', error)
      }
    },
    openCaseDetail(id) {
      if (this.$router && this.$router.resolve) {
        const routeData = this.$router.resolve({ path: '/case_detail/' + id })
        window.open(routeData.href, '_blank')
      }
    },
    startScroll() {
      const scroll = () => {
        if (!this.isPaused) {
          this.scrollOffset += this.scrollSpeed
          
          // 获取单个项目的宽度（包括间距）
          const itemWidth = 400 // 400px宽度 + 2px间距
          const totalWidth = itemWidth * this.caseList.length
          
          // 当滚动到原始列表的末尾时，重置到开始位置
          if (this.scrollOffset >= totalWidth) {
            this.scrollOffset = 0
          }
        }
        
        this.animationId = requestAnimationFrame(scroll)
      }
      
      this.animationId = requestAnimationFrame(scroll)
    },
    pauseScroll() {
      this.isPaused = true
    },
    resumeScroll() {
      this.isPaused = false
    },
    stopScroll() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
        this.animationId = null
      }
    }
  },
  mounted() {
    this.getCasesFunc()
  },
  beforeDestroy() {
    this.stopScroll()
  }
}
</script>

<style lang="scss" scoped>
.case-carousel-section {
  width: 100%;
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -10%;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(64, 158, 255, 0.1) 0%, transparent 70%);
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -50%;
    right: -10%;
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(64, 158, 255, 0.08) 0%, transparent 70%);
    border-radius: 50%;
  }

  @media screen and (max-width: 768px) {
    padding: 50px 0;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
  }
}

.section-title {
  font-size: 42px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #409eff 0%, #66b1ff 100%);
    border-radius: 2px;
  }

  @media screen and (max-width: 768px) {
    font-size: 28px;
  }
}

.carousel-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 768px) {
    padding: 0 10px;
  }
}

.seamless-scroll-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 500px;

  @media screen and (max-width: 768px) {
    height: 300px;
  }
}

.scroll-content {
  display: flex;
  gap: 1px;
  will-change: transform;
}

.case-item {
  flex-shrink: 0;
  width: 400px;
  height: 500px;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    width: 280px;
    height: 300px;
  }
}

.case-image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
  box-shadow: none;
  border-radius: 0;
}

.case-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.5s ease;
  display: block;
}

.case-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.7) 100%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 30px;
}

.case-item:hover {
  .case-image {
    transform: scale(1.05);
  }

  .case-overlay {
    opacity: 1;
  }
}

.case-info {
  text-align: center;
  width: 100%;
}

.view-detail {
  display: inline-block;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  padding: 12px 30px;
  background: rgba(64, 158, 255, 0.9);
  border-radius: 25px;
  transition: all 0.3s ease;

  &:hover {
    background: #409eff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  }

  @media screen and (max-width: 768px) {
    font-size: 14px;
    padding: 8px 20px;
  }
}

@media screen and (max-width: 768px) {
  .case-overlay {
    opacity: 1;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.5) 100%
    );
    padding: 20px;
  }
}
</style>
